import { EncryptedDataPropTypes } from "../../PropTypes/EncryptedDataPropTypes";

const baseURL = `${process.env.REACT_APP_BASE_URL}/api`

const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to perform SSO login
const SocialLoginActionApi = async (
    username: string, // username
    email: string, // email address 
    sub: string //auth ID
): Promise<any> => {

    const url = `${baseURL}/sso-login`;

    const data = new FormData();

    data.append("name", username);
    data.append("email", email);
    data.append("sub", sub);
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: data
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}


// API to perform user login
const UserLoginActionApi = async (
    username: string, // username
    encryptedPassword: EncryptedDataPropTypes // password 
): Promise<any> => {
    const url = `${baseURL}/login`;

    const data = new FormData();

    data.append("email", username);
    data.append("password", encryptedPassword.cipherText);
    data.append("iv", encryptedPassword.iv);
    data.append("salt", encryptedPassword.salt);

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: data
        });
        return await response;
    } catch (error) {
        return Promise.reject;
    }
}

// API to get user details
const getUserDetailsApi = async (
    token: string // access token
): Promise<any> => {

    const url = `${baseURL}/user`;

     /* // Save the original fetch function
     const originalFetch = window.fetch;

     // Mock the fetch function to return a 500 response
     window.fetch = (): Promise<Response> =>
         Promise.resolve({
             status: 500,
             ok: false,
             json: () => Promise.resolve({ message: 'Internal Server Error' }),
         } as Response); */

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            }
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }

    /* window.fetch = originalFetch; */
}

export { UserLoginActionApi, getUserDetailsApi, SocialLoginActionApi }